import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ButtonType } from 'src/app/shared/common/components/buttons/button';
import { CreatePanelView, DetailPanelView } from 'src/app/shared/common/enums/list-panel/panel-view-mode.enum';
import { TCFile } from 'src/app/shared/common/files/TCFile';
import { PanelMenuService } from 'src/app/shared/common/services/panel-menu/panel-menu.service';
import { SurveyJobAttachment } from 'src/app/shared/survey-data-services/survey-job';

@Component({
    selector: 'attach-files',
    templateUrl: './attach-files.component.html'
})
export class AttachFilesComponent implements OnInit, OnDestroy {
    @Input() files: SurveyJobAttachment[] = [];

    @Output() filesSelected = new EventEmitter<TCFile[]>();

    updatedFiles: TCFile[] = [];
    tcFiles: TCFile[] = [];

    isUpdated = false;
    ButtonType = ButtonType;

    constructor(private panelMenuService: PanelMenuService) {}

    ngOnInit(): void {
        this.tcFiles = this.files.map(file => TCFile.fromSurveyJobAttachment(file));
    }

    ngOnDestroy(): void {
        this.cancelEditAction();
    }

    isSelectionUpdated(): boolean {
        if (this.updatedFiles.length !== this.files.length) {
            return true;
        }
        // All updatedFiles must be present in files
        const allPresent = this.updatedFiles.every(updatedFile =>
            this.files.some(file => file.version === updatedFile.id)
        );
        return !allPresent;
    }

    onFilesSelected(files: TCFile[]) {
        this.updatedFiles = files;
        this.isUpdated = this.isSelectionUpdated();
    }

    attachFiles() {
        if (this.isUpdated) {
            this.filesSelected.emit(this.updatedFiles);
        }
        this.cancelEditAction();
    }

    cancelEditAction() {
        this.panelMenuService.detailsPanelViewStream.next(DetailPanelView.Edit);
        this.panelMenuService.createPanelViewStream.next(CreatePanelView.Create);
    }
}
